<template>
  <div class="flex w-full select-none flex-col justify-between rounded-xl p-3">
    <slot />
  </div>
</template>
